// extracted by mini-css-extract-plugin
export var fileExt = "_vi-8";
export var fileIcon = "_vi-6";
export var fileLink = "_vi-5";
export var fileName = "_vi-7";
export var image = "_vi-1";
export var imageError = "_vi-3";
export var imageErrorIcon = "_vi-4";
export var imageLink = "_vi-0";
export var imageLoaded = "_vi-2";